var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 22.4463 0.440078 24.7898 1.24398 26.9564L20 27.826L38.756 26.9565C39.56 24.7898 40 22.4463 40 19.9999C40 17.5535 39.56 15.2101 38.756 13.0434L20 12.1738L1.24398 13.0434C0.440078 15.2101 0 17.5535 0 19.9999H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 -6.10352e-05C11.4006 -6.10352e-05 4.06975 5.42744 1.2439 13.0435H38.756C35.9301 5.42744 28.5992 -6.10352e-05 19.9999 -6.10352e-05V-6.10352e-05Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7559 26.9564H1.2439C4.06976 34.5724 11.4006 39.9999 19.9999 39.9999C28.5992 39.9999 35.9301 34.5724 38.7559 26.9564Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstonia);
export default __webpack_public_path__ + "static/media/estonia.097ac2312cc9cb135b5f0ecc87b7069c.svg";
export { ForwardRef as ReactComponent };